// Portal brand mark — shows the admin-uploaded logo (Theme & Style) if one is
// set, otherwise falls back to the built-in StratusLogo. Used in the sidebar so
// custom branding reflects portal-wide.

import { useQuery } from '@tanstack/react-query';
import { StratusLogo } from './StratusLogo';

export function BrandLogo({ collapsed = false, size, iconOnly = false }: { collapsed?: boolean; size?: number; iconOnly?: boolean }) {
  const cfg = useQuery<any>({
    queryKey: ['theme-config'],
    queryFn: async () => { const r = await fetch('/api/theme/public/config'); return r.ok ? r.json() : {}; },
    staleTime: 60_000,
  });

  const h = size ?? (collapsed ? 26 : 32);
  if (cfg.data?.logo) {
    return (
      <img
        src={`/api/theme/public/logo?v=${cfg.data.logo_v || 0}`}
        alt="Logo"
        style={{ height: h, maxWidth: size ? size * 4 : (collapsed ? 40 : 168), objectFit: 'contain' }}
      />
    );
  }
  const iconSize = size ?? (collapsed ? 38 : 52);
  const withText = !collapsed && !iconOnly && size == null;
  return withText
    ? (
      <span className="flex items-center gap-2 min-w-0">
        <StratusLogo size={iconSize} withText={false} className="text-primary shrink-0" />
        <span className="stratus-wordmark text-sm font-black uppercase tracking-tight leading-none whitespace-nowrap">Stratus</span>
      </span>
    )
    : <StratusLogo size={iconSize} withText={false} className="text-primary" />;
}

export default BrandLogo;
